/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { MobileTask } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class MobileTasksController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags mobile-tasks-controller
   * @name GetMobileTasks
   * @request GET:/api/m/mobile-tasks
   */
  getMobileTasks = (params: RequestParams = {}) =>
    this.http.request<MobileTask[], any>({
      path: `/m/mobile-tasks`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getMobileTasksPath = '/m/mobile-tasks'
  static getMobileTasksMethod = 'GET'
}
